export const iconFontAwesomeCommunicationMobileRetro = (
	<i className="fa-solid fa-mobile-retro"></i>
);
